export interface StreamingPlacementAndDerivedNetwork {
  placement: string;
  placement_code: string;
  derived_id: string;
  campaign_id: number;
  media: string;
  format: string;
  publisher: string;
}

export interface ConstraintListElement {
  lastmodified: string;
  lastuser: string;
  name: string;
  optimizationType: string;
  start: string;
  end: string;
}

export interface RunResult {
  Cost: string;
  'Number of Impressions': string;
  'Placement Code': string;
  'Placement ID': string;
}

export const RUN_TABS = {
  POST_OPTIMIZATION: 'post-optimization',
  SUMMARY: 'summary',
  CONSTRAINT_DEBUGGER: 'constraint-debugger'
} as const;

export interface StreamingOptimizationPageProps {
  company: string;
  streamingType: string;
}
